/* Built-ins that the browsers in our browserslist do not all have. @babel/preset-env is configured
   without `useBuiltIns` and there is no core-js, so nothing polyfills them — code that has to run on
   the oldest engines we still serve calls these instead. */

export const flatMap = (values, iteratee) => values.reduce(
    (result, value) => result.concat(iteratee(value)),
    [],
);

export const startsWith = (value, prefix) => value.indexOf(prefix) === 0;
